/* eslint-disable max-len */
import { ChartTypes } from '@configs/graph';
import { sortOrders } from '@constants/sort';
import { IReportConfig } from '@typings/reports';

const reportConfig: IReportConfig = {
    reportTitle: 'Операционные системы',
    tableDataType: 'dynamic',
    tableTitle: 'ОС, версия',
    defaultSort: {
        name: 'visits',
        order: sortOrders.DESC,
    },
    numberOfGraphs: 'two',
    defaultGraphs: [
        ChartTypes.pie,
        ChartTypes.bar,
    ],
    graphDefaultMetrics: [
        'visits',
        'visitors',
    ],
    childrenTitleDelimiter: [' ', '.'],
    tableDefaultMetrics: [
        'visits',
        'page_views',
        'visitors',
    ],
    availableMetrics: [
        'visits',
        'avg_view_depth',
        'page_views',
        'visitors',
        'uid',
        'rambler_id',
        // 'bounces',
        // 'avg_industry_duration',
    ],
    isShowTotals: true,
    availableTools: {
        numberOfGraphs: true,
        periodPicker: true,
        sample: true,
        activeSample: true,
        filters: true,
        savedFilters: true,
        detail: true,
    },
    reportHint: {
        message: 'Данные о том, какими операционными системами, а также какими их версиями пользуются посетители вашего сайта. '
            + 'Доступные показатели: посетители, визиты, '
            + '<a href="https://ads.sber.ru/help/metod-dlya-peredachi-identifikatora-polzovatelya" target="_blank">пользователи</a>, '
            + 'просмотры, отказы, время на сайте, глубина просмотра.',
    },
};

export default reportConfig;
